import {
  DataTable as SharedDataTable,
  SimpleTable as SharedSimpleTable,
  type BaseData,
  type BaseTableData,
  type DataTableProps,
  type SimpleTableProps,
} from "@promptlayer/ui";

const AG_GRID_LICENSE_KEY = import.meta.env.REACT_APP_AG_GRID_LICENSE_KEY;

export function DataTable<DataT extends BaseData>({ licenseKey, ...props }: DataTableProps<DataT>) {
  return <SharedDataTable<DataT> {...props} licenseKey={licenseKey ?? AG_GRID_LICENSE_KEY} />;
}

export function SimpleTable<T extends BaseTableData>({
  licenseKey,
  ...props
}: SimpleTableProps<T>) {
  return <SharedSimpleTable<T> {...props} licenseKey={licenseKey ?? AG_GRID_LICENSE_KEY} />;
}

export type {
  BaseData,
  BaseTableData,
  DataTableProps,
  SimpleTableColumn,
  SimpleTableProps,
} from "@promptlayer/ui";

export { GridSelectionStore, type GridSelectionMode } from "./ag-grid-table/grid-selection-store";
export { createGridSelectionContext } from "./ag-grid-table/createGridSelectionContext";
export { createGridSelectionHelpers } from "./ag-grid-table/createGridSelectionHelpers";
export { createGridSelectionCells } from "./ag-grid-table/createGridSelectionCells";
export type { HistoryImportConfig } from "./ag-grid-table/historyImportConfig";
export {
  HistoryImportActionButton,
  assertExactOneSelection,
  isExactOneSelected,
  submitHistoryImport,
} from "./ag-grid-table/historyImportAction";
export { default as GridSelectionLimitControl } from "./ag-grid-table/GridSelectionLimitControl";
export { default as GridSelectionSelectAllMatching } from "./ag-grid-table/GridSelectionSelectAllMatching";
export { useGridSelectionActionBarLimit } from "./ag-grid-table/useGridSelectionActionBarLimit";
